import React, { useRef } from 'react';
import TextWithInputs from 'src/pages/reportUsage/common/textWithInputs/TextWithInputs';
import TextWithClicks from 'src/pages/reportUsage/common/textWithClicks/TextWithClicks';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import ItemPrices from '../ItemPrices';
import edit from 'src/assets/images/Edit.svg';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import LotSerialQtyInput from '../LotSerialQtyInput';
import collapseIcon from 'src/assets/images/SmallDownArrow.svg';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { sizes } from 'src/styles/Media.styled';
import { ExpandCollapseIcon } from 'src/pages/reportUsage/utils/reportUsage.styled';
import styled from 'styled-components';
import DeleteLight from 'src/assets/images/DeleteLight.svg';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { BROWN_FONT_COLOR, SEMANTIC_TEXT_SMALL_PX, X_SMALL_TEXT_PX } from 'src/styles/fonts/MCFontConstants';
import { logErrorToConsole } from 'src/utils/util';

const ItemTemplateDesktop = ({
    classes,
    item,
    index,
    editItem,
    editedItemList,
    addSerialNumber,
    lotSerialValueEntered,
    onAccountOwnedSeleted,
    onIsSerialUnknown,
    deleteItem,
    displayPrice,
    showBundlefromTableList,
    isChildItem,
    bundleExpandCollapseIconClickHandler,
    isFromReportScreen,
    checkNewAddedProduct,
    vendorCaseErrorRedirection,
    childRef,
}) => {
    const { t } = useTranslation();
    const { isLanguageChanged } = useSelector((state) => state.loginReducer);
    const winWidth = window.innerWidth;
    const isFromTabView = winWidth >= sizes.smalDevice && winWidth <= sizes.mediumDevice;
    const mediaSizes = {
        titleArea: 6,
        buttonnsArea: 6,
        xs: 3,
        lg: 2,
    };
  
    return (
        <>
            <div style={{ display: 'flex' }}>
                <div
                    style={{
                        width: isChildItem ? '238px' : '256px',
                        marginRight: item.isBundleItem
                            ? '44px'
                            : isChildItem
                            ? '20px'
                            : '40px',
                    }}
                >
                    <span style={{ display: 'flex' }}>
                        {(isFromReportScreen || checkNewAddedProduct) && (
                            <Checkbox
                                checked={item.cfn}
                                id="reportUsage-record-itemsList-ItemListContainerDesktop-FromReportScreen"
                                margin={'0px 5px 10px 1px'}
                                labelStyleObj={{
                                    fontSize: SEMANTIC_TEXT_SMALL_PX,
                                    color: BROWN_FONT_COLOR,
                                }}
                                background={'none'}
                                checkboxBorder={'1.5px solid #555555'}
                                alignItemDirection={'center'}
                                hoverEffect={'false'}
                                disableFocusEffect={'true'}
                            />
                        )}
                        {!isChildItem && item.isBundleItem && (
                            <ExpandCollapseIcon
                                src={collapseIcon}
                                alt="down-arrow"
                                isExpanded={item.isBundleExpanded}
                                width="20px"
                                height="20px"
                                id={`expand-collapse-icon-${item.cfn || index}`}
                                onClick={(e) =>
                                    bundleExpandCollapseIconClickHandler(
                                        e,
                                        item,
                                        index
                                    )
                                }
                            />
                        )}
                        {item.isEditable ||
                        (item.isInvalidItemMsg === t('reportUsage.procedure.unidSurgery.SurgeryOrReport.ProductNotfound') &&
                            !item.isBundleItem) ? (
                            <TextWithInputs
                                type="text"
                                autoFocus={true}
                                name="cfn"
                                defaultValue={item.cfn ? item.cfn : ''}
                                onkeyUp={(e) => editedItemList(e, item, index)}
                                inputHeight={'40px'}
                                inputBorder={
                                    item.isInvalidItemMsg
                                        ? '2px solid #FACFD9'
                                        : '2px solid #EBEDED'
                                }
                            />
                        ) : (
                            <div
                                style={{
                                    display: 'flex',
                                    width: '100%',
                                }}
                            >
                                {isFromReportScreen ? (
                                    <TextWithClicks
                                        style={{
                                            marginLeft: '10px',
                                        }}
                                        classes={classes}
                                        media={mediaSizes}
                                        leftTitle={item.cfn}
                                        typeNonTissue={
                                            !item.isBundleItem &&
                                            (item.salesOrg === 'S002'
                                                ? 'NT'
                                                : item.salesOrg === 'S030'
                                                ? 'T'
                                                : undefined)
                                        }
                                        typeEA={!item.isBundleItem && item.uom}
                                        alignItemsVal={'flex-start'}
                                        justifyContentVal={'flex-end'}
                                        editMarginLeft={
                                            item.isBundleItem
                                                ? '5px'
                                                : !item.uom &&
                                                  !item.salesOrg &&
                                                  !item.isBundleItem &&
                                                  '0px'
                                        }
                                        typeBundle={
                                            item.isBundleItem && 'BUNDLE'
                                        }
                                    />
                                ) : (
                                    <TextWithClicks
                                        classes={classes}
                                        media={mediaSizes}
                                        leftTitle={item.cfn}
                                        typeNonTissue={
                                            !item.isBundleItem &&
                                            (item.salesOrg === 'S002'
                                                ? 'NT'
                                                : item.salesOrg === 'S030'
                                                ? 'T'
                                                : undefined)
                                        }
                                        typeEA={!item.isBundleItem && item.uom}
                                        buttonImg={edit}
                                        editAction={() => editItem(item, index)}
                                        alignItemsVal={'flex-start'}
                                        justifyContentVal={'flex-end'}
                                        editMarginLeft={
                                            item.isBundleItem
                                                ? '5px'
                                                : !item.uom &&
                                                  !item.salesOrg &&
                                                  !item.isBundleItem &&
                                                  '60px'
                                        }
                                        mlTissueNontissue={
                                            window.innerWidth >
                                            sizes.mobileDevice
                                                ? '6rem'
                                                : ''
                                        }
                                        mrBundle={
                                            window.innerWidth >
                                            sizes.mobileDevice
                                                ? '0.5rem'
                                                : ''
                                        }
                                        mlBundle={
                                            window.innerWidth >
                                            sizes.mobileDevice
                                                ? '2rem'
                                                : ''
                                        }
                                        typeBundle={
                                            item.isBundleItem && 'BUNDLE'
                                        }
                                        screenType="desktop"
                                    />
                                )}
                            </div>
                        )}
                    </span>
                    {!item.isEditable && item.description && (
                        <CustomLabel
                            margin={'dd'}
                            fSize={'13px !important'}
                            label={item.description}
                            itemDescription={item.description && true}
                            letterSpacing={'-0.1px'}
                            color={'#000000'}
                            fontFamily={'AvenirNextWorld Regular'}
                            paddingLeft={
                                item.isBundleItem && !isChildItem && '25px'
                            }
                        />
                    )}

                    {item.isInvalidItemMsg && (
                        <div
                            style={{
                                display: 'flex',
                                width: isChildItem ? '100%' : '90%',
                                paddingTop: '10px',
                            }}
                        >
                            <AlertMsg message={item.isInvalidItemMsg} />
                        </div>
                    )}
                </div>

                <div
                    style={{
                        width: '312px',
                        marginRight: isChildItem ? '0px' : '20px',
                    }}
                >
                    {item.lotSerial &&
                        item.lotSerial.map((lotItem, lotItemIdx) => {
                            return (
                                <div key={lotItemIdx} style={{ marginBottom: '10px'}}>
                                    <LotSerialQtyInput
                                        isFromReportScreen={isFromReportScreen}
                                        item={item}
                                        index={index}
                                        lotItem={lotItem}
                                        lotItemIdx={lotItemIdx}
                                        addSerialNumber={addSerialNumber}
                                        lotSerialValueEntered={
                                            lotSerialValueEntered
                                        }
                                        deleteItem={deleteItem}
                                        showBundlefromTableList={
                                            showBundlefromTableList
                                        }
                                        isChildItem={isChildItem}
                                        key={lotItem + ' ' + lotItemIdx}
                                        vendorCaseErrorRedirection={
                                            vendorCaseErrorRedirection
                                        }
                                        ref={childRef}
                                        onIsSerialUnknown={onIsSerialUnknown}
                                    />
                                     {/* removed as a part of defect 21622 */}
                                    {/* <CustomLabel
                                        fSize={'13px!important'}
                                        fontFamily={'AvenirNextWorld Regular'}
                                        color="#1010EB"
                                        cursor={'pointer'}
                                        opacity={1}
                                        label={`${'+'}${t('reportUsage.itemList.lotorserial')}`} // 1234
                                        onLabelClick={() => {
                                            if (childRef.current) {
                                                childRef.current.bottomLabelClickHandler();
                                            }
                                        }}
                                        paddingTop={'0px'}
                                        paddingLeft={'0px'}
                                        letterSpacing={'-0.11px'}
                                        fWeight={'normal'}
                                    /> */}
                                </div>
                            );
                        })}
                  
                    {isFromReportScreen &&
                        item.lotSerial &&
                        item.lotSerial.map((lotItem, lotItemIdx) => {
                            return (
                                <Grid
                                    item
                                    md={1}
                                    lg={1}
                                    xl={1}
                                    style={{ marginLeft: '395px' }}
                                    key={lotItem + ' ' + lotItemIdx}
                                >
                                    <Box
                                        component={Button}
                                        aria-controls="simple-menu-1"
                                        aria-hospopup="true"
                                        size="small"
                                        width={'40px !important'}
                                        height={'40px !important'}
                                        minWidth={'40px !important'}
                                        minHeight={'40px !important'}
                                        border="1px solid #EBEBEB"
                                        marginRight={
                                            !item.isBundleItem && '-5px'
                                        }
                                        marginTop={
                                            lotItemIdx === 0 ? '20px' : '5px'
                                        }
                                        borderRadius={6}
                                        id={`delete-lotserial-btn-${index}-${lotItemIdx}`}
                                        onClick={() =>
                                            deleteItem(index, lotItemIdx)
                                        }
                                    >
                                        <img
                                            src={DeleteLight}
                                            height={24}
                                            width={24}
                                        />
                                    </Box>
                                </Grid>
                            );
                        })}
                </div>

                <StyledDiv width={'120px'}>
                    {item.basePrice && !isChildItem && !isFromReportScreen && (
                        <StyledDiv margin={isLanguageChanged ? '10px 5px 0px 16px' : '0px 5px 0px 16px'}>
                            {!item.isBundleItem && (
                                <Checkbox
                                    label={t(
                                        'reportUsage.record.itemsList.itemTemplateDesktop.accountOwned'
                                    )}
                                    checked={item.accountOwned}
                                    onCheckboxSelectionChange={() =>
                                        onAccountOwnedSeleted(item, index)
                                    }
                                    id="reportUsage-record-itemsList-ItemListContainerDesktop-accountOwned"
                                    margin={'0px 8px 0px 0px'}
                                    labelStyleObj={{
                                        fontSize: X_SMALL_TEXT_PX,
                                        color: BROWN_FONT_COLOR,
                                    }}
                                    background={'none'}
                                    checkboxBorder={'1.5px solid #555555'}
                                    alignItemDirection={'center'}
                                    hoverEffect={'false'}
                                    disableFocusEffect={'true'}
                                />
                            )}
                        </StyledDiv>
                    )}
                </StyledDiv>

                {!isChildItem && !isFromReportScreen && (
                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 'auto', width: '300px' }}>
                        <ItemPrices
                            classes={classes}
                            item={item}
                            displayPrice={displayPrice}
                            itemPricesWidth={'300px'}
                            isBundleItem={item.isBundleItem}
                            marginLeft={item.isBundleItem && '-20px'}
                            isFromReportScreen={isFromReportScreen}
                        />
                        {/* Show '+Lot/Serial' link aligned under Exit Price when checkbox is present */}
                        {
                            (item?.lotSerialUnknownApplicable &&  (item?.isSerialRequired || item?.isBatchRequired)) &&
                            !item.isInvalidItemMsg &&
                            item.lotSerial &&
                            item.lotSerial.length > 0 && (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        paddingRight:'0px', // Desktop
                                        marginTop: '21px',
                                        marginBottom: '10px',
                                        cursor: 'pointer',
                                        width: '100%',
                                        minWidth: '0',
                                        overflow: 'visible',
                                        boxSizing: 'border-box',
                                    }}
                                    onClick={() => {
                                        try {
                                        if (item.isBundleItem) {
                                            showBundlefromTableList(true, index, item.cfn, item?.unqId);
                                        } else {
                                            addSerialNumber(item, index);
                                        }
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                >
                                    <span
                                        style={{
                                            color: '#1010EB',
                                            fontSize:
                                                isFromTabView
                                                    ? winWidth === sizes.smalDevice
                                                        ? '11px' // iPad Mini
                                                        : '12px' // iPad Air/Pro
                                                    : window.innerWidth >= 768 && window.innerWidth <= 1200
                                                    ? '12px'
                                                    : '13px', // Desktop
                                            fontFamily: 'AvenirNextWorld Regular',
                                            letterSpacing: '-0.11px',
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        {item.isBundleItem || item.materialType === 'DIEN'
                                            ? '+' + t('reportUsage.addItems.title')
                                            : '+' + t('reportUsage.itemList.lotorserial')}
                                    </span>
                                </div>
                            )}
                    </div>
                )}
              
            </div>
        </>
    );
};

export default ItemTemplateDesktop;

const StyledDiv = styled.div`
    width: ${({ width }) => width};
    margin: ${({ margin }) => margin};
`;
